import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { updateCategoryOrder } from "../../services/categories";

interface IPayload {
    categoryId: number;
    action: 'up' | 'down';
}

const useUpdateCategoryOrder = () => {
    const mutationFn = async (payload: IPayload) => {
        return await updateCategoryOrder(payload.categoryId, payload.action);
    }

    return useMutation({
        mutationFn,
        onError: (error: any) => {
            toast.error(error.response?.data?.message);
        }
    });
}
export default useUpdateCategoryOrder;